var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CusstomEditor"},[_c('Editor',{style:({ 'height': _vm.height }),attrs:{"defaultConfig":_vm.editorConfig,"mode":_vm.mode},on:{"onChange":_vm.onChange,"onCreated":_vm.onCreated},model:{value:(_vm.html),callback:function ($$v) {_vm.html=$$v},expression:"html"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }